<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<ng-container *ngIf="!isLoading">

  <div class="stats">
    <div class="stat">
      <i class="fa-solid fa-users"></i>
      <div>
        <small>Total Referrals</small>
        <b>{{ amountData.length }}</b>
      </div>
    </div>
    <div class="stat">
      <i class="fa-solid fa-gift"></i>
      <div>
        <small>Total Bonus</small>
        <b>{{ totalBonus | number : '1.2-2' }}</b>
      </div>
    </div>
  </div>

  <div class="pcard">
    <h2><i class="fa-solid fa-gift"></i> Bonus Amount</h2>

    <div class="tbl-wrap" *ngIf="amountData.length > 0">
      <table class="tbl">
        <thead>
          <tr>
            <th>Date</th>
            <th>Email</th>
            <th>Total Package Amount</th>
            <th>Bonus Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let amt of amountData">
            <td>{{ amt.PurchasedDate }}</td>
            <td>{{ amt.whoPurchased }}</td>
            <td>{{ amt.totalPackageAmount }}</td>
            <td>{{ amt.bonusAmount }}</td>
            <td><span class="tag">{{ amt.status }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="empty" *ngIf="amountData.length === 0">No referrals yet.</p>
  </div>

</ng-container>
